define(function(require) {
    const BaseController = require('pages/Base.controller');
    const TokensView = require('./Tokens.view');
    const controller = new BaseController({
        baseView: true,
        context: '/user/tokens',
        navViewOptions: {
            breadcrumbViewOptions: {
                pageContext: 'User Account',
                pageDescription: 'API Tokens',
                showIcon: false
            }
        },
        routes: [
            {
                name: 'default',
                path: '*default',
                module: TokensView,
                element: '.content-container',
                pageScheme: 'page-scheme-umbra'
            }
        ]
    });
    controller.start();
    return controller;
});
